import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ContentContainer from "../../templates/content-container/contentContainer";
import ContentContainerToolbar from "../../ui-components/molecules/content-container-toolbar/contentContainerToolbar";
import PageLoading from "../page-loading/pageLoading";
// import AccountDetailsCompanySummary from "./accountDetailsCompanySummary";
import AccountDetailsCompanyInfo from "./accountDetailsCompanyInfo";
import AccountDetailsSalesman from "./accountDetailsSalesman";
import AccountDetailsAgingSummary from "./accountDetailsAgingSummary";
import AccountDetailsClaims from "./accountDetailsClaims";
import AccountDetailsInvoices from "./accountDetailsInvoices";
// import AccountDetailsRevenue from "./accountDetailsRevenue";
import AccountDetailsAccounts from "./accountDetailsAccounts";

import { accountDetailsSelector, getAccountDetailsAccounts, getAccountDetailsCompanyInfo,/*, getAccountDetailsCompanySummary, getAccountDetailsRevenue */
getAccountDetailsInvoices} from "../../slices/account-details/accountDetailsSlice";
import { cn } from "../../services/common/className";
import { getAging } from "../../slices/aging/agingSlice";
import { getClaimsList } from "../../slices/claims/claimsSlice";
import XGSErrorMessage from "../../ui-components/error-message/errorMessage";

import "./accountDetails.scss";

const AccountDetails: React.FC<{}> = (props) => {
  const { accountNumber } = useParams<{ accountNumber: string }>();
  const dispatch = useDispatch();
  const accountDetailsState = useSelector(accountDetailsSelector);

  useEffect(() => {
    if (!accountNumber) return;

    dispatch(getAccountDetailsCompanyInfo(accountNumber));
    // dispatch(getAccountDetailsCompanySummary(accountNumber));
    dispatch(getClaimsList({ accountNumber }));
    dispatch(getAccountDetailsInvoices(parseInt(accountNumber)));
    // dispatch(getAccountDetailsRevenue(accountNumber));
    

  }, [accountNumber, dispatch])

  useEffect(() => {
    if (!accountDetailsState.companyInfo?.accountId) return;

    dispatch(getAging(accountDetailsState.companyInfo?.id));

    if (accountDetailsState.companyInfo?.payor) {
      dispatch(getAccountDetailsAccounts(accountDetailsState.companyInfo?.teamId, accountDetailsState.companyInfo?.accountId));
    }
  }, [accountDetailsState.companyInfo, dispatch])

  return (
    <ContentContainer
      className="xgs-list xgs-list--full-width account-details"
      mods={{ "full-width": true }}
      titleComponent={
        <ContentContainerToolbar
          title={accountDetailsState.companyInfo?.accountName}
          mods={{ "full-width": true }}
        />
      }
    >
      {accountDetailsState.request["GET_COMPANY_INFO"]?.requestStarted
        ? <PageLoading isLoading={true} />
        : accountDetailsState.request["GET_COMPANY_INFO"]?.requestFailed
          ? <XGSErrorMessage>{accountDetailsState.request["GET_COMPANY_INFO"]?.requestError}</XGSErrorMessage>
          : <>
            {/* <AccountDetailsCompanySummary /> */}

            <div className="account-details__cards">
              <div className={cn("account-details__cards__column")({ fixed: true })}>
                <AccountDetailsCompanyInfo />
                <AccountDetailsSalesman />
              </div>
              <div className={cn("account-details__cards__column")({ "full-width": true })}>
                <AccountDetailsAgingSummary />
                <AccountDetailsInvoices />
                <AccountDetailsClaims />
                {/* <AccountDetailsRevenue /> */}

                {accountDetailsState.companyInfo?.payor && <AccountDetailsAccounts />}
              </div>
            </div>
          </>
      } 
    </ContentContainer>
  );
};

export default AccountDetails;